module.exports = __webpack_public_path__ + "img/img145.9dafbad4.png";